module.exports = __webpack_public_path__ + "img/hr-H-B-123456-unload-standup-base.ad2c2081.png";